import Vue from 'vue';
import Component from 'vue-class-component';
import { G2S } from 'core/g2s';
import * as api from 'core/api';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class SupportAllrequestsComponent extends Vue {
    view = 'loading';

    tickets: api.SupportTicket[] = [];

    expandedTicketIndexes: number[] = [];

    commentsHeadLength = 3;

    mounted() {
        this.loadModel();
    }

    loadModel() {
        const marketCode = G2S.config.marketCode;
        const locale = G2S.config.locale;

        new api.SupportService().getHistory(marketCode, locale).then(
            (result) => {
                this.tickets = result.tickets;

                this.view = 'view';
            },
            (error) => {
                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }

                this.view = 'view';
            }
        );
    }

    isExpanded(ticketIndex: number) {
        return this.expandedTicketIndexes.includes(ticketIndex);
    }

    toggleComments(ticketIndex: number) {
        if (this.isExpanded(ticketIndex)) {
            this.expandedTicketIndexes = this.expandedTicketIndexes.filter(index => index !== ticketIndex);
        } else {
            this.expandedTicketIndexes.push(ticketIndex);
        }
    }

    getComments(ticketIndex: number) {
        const comments = this.tickets[ticketIndex].comments;

        if (this.isExpanded(ticketIndex)) {
            return comments;
        } else {
            return comments.slice(0, this.commentsHeadLength);
        }
    }
}
